module.exports = __webpack_public_path__ + "static/media/foto_04.21a3c3e2.jpg";